import * as Yup from "yup";
import { useFormik } from "formik";
import { FormInput, Button, FormError } from "@/components/Shared";

const VehicleRegForm: React.FC<{
	insuranceLink?: string;
	onClick?: () => void;
}> = ({ insuranceLink, onClick }) => {
	const formik = useFormik({
		initialValues: { reg: "" },
		validationSchema: Yup.object().shape({
			reg: Yup.string().matches(
				/^\s*[A-Za-z]{1,3}\s*[0-9]{1,3}\s*[A-Za-z]{1,3}\s*$/,
				"Please enter a valid UK number plate"
			),
		}),
		onSubmit: (values, { setSubmitting }) => {
			onClick && onClick();
			const insuranceLinkWithReg = `${insuranceLink}&reg=${values.reg}`;
			window.location.href = insuranceLinkWithReg;
			setSubmitting(false);
		},
	});

	return (
		<form onSubmit={formik.handleSubmit}>
			<div className="d-flex flex-column">
				<div className="row justify-content-md-start justify-content-center mt-3">
					<div className="col-md-8 mb-3 mb-md-0">
						<FormInput
							name="reg"
							value={undefined}
							handleChange={formik.handleChange}
							placeholder="ENTER REG (optional)"
							isRequired={false}
						/>
					</div>
					<div className="col-md-4 mb-3">
						<Button
							type="submit"
							name="button"
							title={"Get Quotes"}
							isLoading={formik.isSubmitting}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
						<div className="text-white">
							{formik.touched.reg && formik.errors.reg ? (
								<FormError message={formik.errors.reg} theme="light" />
							) : null}
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

export default VehicleRegForm;
